import axios from "axios"


export const verifyEmail = async (emailToVerify) => {
  // console.log('emailVerify called')

  const {data} = await axios.get(`https://tonviska.is/api/v1/vmail/${emailToVerify}`)
  // const {data} = await axios.get(`https://tonviska.is/api/v1/controller/email/verifyemail.php?email=${emailToVerify}`)

  const {code, status} = data.data

  // console.log('verifierStatus', status)

  if (status === 'valid') {
    // console.log('emailVerifier: is valid')
    return {error: false, message: '', code: code, status: true}
  }
  else if (status === 'mailbox_full') {
    return {error: false, message: 'Pósthólf er fullt og tekur ekki við pósti', code: code, status: false}
  }
  else if (status === 'unknown') {
    return {error: true, message: 'Pósthólf finnst ekki', code: code, status: false}
  }
  else if (status === 'failed') {
    return {error: true, message: 'Pósthólf finnst ekki', code: code, status: false}
  }
  else {
    return {error: true, message: status, code: code, status: false}
  }
}